// Page À propos - Présente l'application SmoFR et ses objectifs

import React, { Component } from "react";

export default class About extends Component {
  render() {
    return (
      <div className="flex-grow">
        <div className="w-full max-w-screen-xl mx-auto p-4">
          <h2 className="text-2xl font-semibold mb-4">À propos</h2>
          <p>
            La plateforme Observatoire de la mobilité gérée par le service de la
            mobilité du canton de Fribourg a été conçue pour centraliser et
            organiser des ressources clés liées aux projets et initiatives en
            matière de mobilité. Vous y trouverez un répertoire complet de liens
            et de documentations couvrant des sujets allant des tableaux de bord
            analytiques (Abonnements TP, Accidents de la circulation etc.) à des
            indicateurs utiles et parlants. Que vous soyez à la recherche de
            données pour un nouveau projet, d'informations sur les API
            disponibles, ou de directives pour utiliser nos tableaux de bord
            internes, cette plateforme est votre point de référence pour accéder
            rapidement et efficacement à ces ressources. Die vom Mobilitätsamt
            des Kantons Freiburg betriebene Plattform „Observatoire de la
            mobilité“ wurde entwickelt, um wichtige Ressourcen im Zusammenhang
            mit Mobilitätsprojekten und -initiativen zu bündeln und zu
            strukturieren. Dort finden Sie ein umfassendes Verzeichnis mit Links
            und Dokumentationen zu Themen, die von analytischen Dashboards
            (ÖV-Abonnemente, Verkehrsunfälle usw.) bis hin zu nützlichen und
            aussagekräftigen Indikatoren reichen. Ganz gleich, ob Sie Daten für
            ein neues Projekt, Informationen zu verfügbaren APIs oder
            Anleitungen zur Nutzung unserer internen Dashboards suchen – diese
            Plattform ist Ihre Anlaufstelle für den schnellen und effizienten
            Zugriff auf diese Ressourcen.
          </p>
        </div>
      </div>
    );
  }
}
